<mvs-crud-page
        [objectStructureRequest]="objectBrowserRequest"
        mainObjectType="cm.InsuranceType"
        [mainObjectTypeStructureRequest]="subObjectBrowserRequest"
>
</mvs-crud-page>
